// First, before anything can reach pdf.js: see the file for which browsers
// need which of them.
import './app/polyfills';

// Inter, self-hosted. See the file: a <link> to Google would be blocked by
// our own Content Security Policy, and would leak the signer's IP address.
import './app/fonts.css';

import { CssBaseline, ThemeProvider } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { AuthProvider } from '@/auth/AuthProvider';
import { queryClient } from '@/shared/api/queryClient';
import { branding } from './app/branding';
import { router } from './app/router';
import { buildTheme } from './app/theme';

document.title = branding.appName;

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

createRoot(container).render(
  <StrictMode>
    <ThemeProvider theme={buildTheme()}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
